export default __webpack_public_path__ + "images/KC.2247bbf.png";